module.exports = __webpack_public_path__ + "img/init-setup.951ea1d7.png";